import styled from 'styled-components';
import {mobileMedia, WHITE2} from '../../globalVariables/GlobalVariables';
import {alignCenter, dFlex, justifyCenter} from '../../globalVariables/GlobalFlex';

export const container = styled.div`
  width: 100%;
  height: 100vh;
  min-height: 100vh;
  ${dFlex}
  ${justifyCenter};
  ${alignCenter};
  background-color: ${WHITE2};
  overflow-y: auto;
  overflow-x: hidden;
  ${mobileMedia}{
    display: block;
    padding-inline: 2vw;
    padding-top: 20px;
    padding-bottom: 20px;
  }
`;
